import React from "react";
import styles from "./MosaicLayout.module.scss";
import clsx from "clsx";
import { ImageAspectRatio } from "../ImageRatio/ImageRatio";

export type MosaicLayoutVariantType =
  | "column2"
  | "column3"
  | "column2+3"
  | "column4";
export interface MosaicLayoutProps {
  variant: MosaicLayoutVariantType;
}

export const MosaicLayout: React.FC<
  React.PropsWithChildren<MosaicLayoutProps>
> = ({ variant = "column3", children, ...otherProps }) => {
  return (
    <div
      className={clsx(styles.mosaic, {
        [styles.variantColumn3]: variant == "column3",
        [styles.variantColumn2]: variant == "column2",
        [styles.variantColumn23]: variant == "column2+3",
        [styles.variantColumn4]: variant == "column4"
      })}
      {...otherProps}
    >
      {children}
    </div>
  );
};

export const cardImageRatioForMosaicIndex = (
  variant: MosaicLayoutVariantType,
  index: number
): ImageAspectRatio => {
  if (variant == "column2") return "card-panorama";

  if (variant == "column3") return "card";
  if (variant == "column4") return "rectangular";

  if (variant == "column2+3") if (index < 2) return "card-panorama";
  return "card";
};
